<div class="container-fluid">
    <div class="row pt-3">
        <div class="d-flex justify-content-between w-100  mt-2 pointer mb-4">
           
            <h3 class="mb-0">Tree Listddf</h3>

            <button class="ct_animation_btn_121 ct_custom_btn121 " (click)="showBasicDialog()">+ Create</button>
        </div>
    </div>

    <p-dialog  [(visible)]="displayBasic" [breakpoints]="{'960px': '75vw'}" [closable]="false"
    [style]="{width: '50vw'}">
    <p-header > Add New Tree </p-header>
    <!-- <p-header *ngIf="FormEdit === true"> Edit Group </p-header> -->

    <div class="modal-body text-white text-style Dashboard-tab">
        <form #GroupForm="ngForm" (ngSubmit)="onSubmit(GroupForm)" class="col-12">
            <div class="mb-5 pb-5">
               <div class="mb-3">
                <label for="fname" class="text-dark">Tree name</label>
                <input ngModel name="treename" id="search-input" type="text"
                    class="form-control Dashboard-tab text-white" placeholder="Enter Tree Name"
                    #groupName="ngModel"  
                    required />
               </div>
              <div class="mb-3">
                <label for="fname" class="mt-2 text-dark">Total Members</label>
                <input ngModel name="totalMembers" id="search-input" type="text"
                class="form-control Dashboard-tab text-white" placeholder="Enter No of Members"
                #groupName="ngModel" 
                required />
              </div>
               <div class="mb-3">
                <label for="fname" class="mt-2 text-dark">Root Name</label>
                <input ngModel name="rootName" id="search-input" type="text"
                class="form-control Dashboard-tab text-white" placeholder="Enter Root Name"
                #groupName="ngModel"
                required />
               </div>

               <div class="mb-3">
                <label for="fname" class="mt-2 text-dark">Name</label>
                <input ngModel name="name" id="search-input" type="text"
                class="form-control Dashboard-tab text-white" placeholder="Enter Name"
                #groupName="ngModel"
                required />
               </div>
           
            </div>

            <div class="mt-3 ct_modal_btns_12">
                <Button  type="submit" class="rounded  py-2 ct_custom_btn121 ct_animation_btn_121 span-color px-3 text-white text-style loading ">
                    Save
                </Button>
                <!-- <Button *ngIf="FormEdit === true" type="submit "
                    class="rounded span-color px-3 text-white text-style">
                    <p-progressSpinner strokeWidth="8" ></p-progressSpinner>
                    Update
                </Button> -->

                <span type="button" class="text-dark py-2 font-weight-light ml-3 " 
                    (click)="displayBasic=false">
                    Close
                </span>
            </div>
        </form>
    </div>
</p-dialog>

    <ng-container *ngIf="treeList$ | async as list ">
       
            <div class="card ct_dash_board_tab border-0 p-4">
                <h5 class="mb-4">Single</h5>
           
                 <p-table class="ct_tree_list_table" [value]="list.familyDetails" selectionMode="single" [(selection)]="selectedTree" dataKey="id"> 
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Tree name</th>
                            <th>Total users</th>
                         
                            <th>Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <tr [pSelectableRow]="product">
                            <td>{{product.family_name}}</td>
                            <td>{{product.total_family_members}}</td>
                            <td> <p (click)="viewTree(product.id)" class="mb-0 ct_view_eye ct_animation_btn_121"> <i class="fa fa-eye" aria-hidden="true"></i></p><p class="mb-0 ct_animation_btn_121 ct_trush_icon"><i class="fa fa-trash" aria-hidden="true"></i></p></td>
                
                        </tr>
                    </ng-template>
                </p-table> 
            </div>
      
      
    </ng-container>
</div>

